import { render, staticRenderFns } from "./SignInWithGoogle.vue?vue&type=template&id=71f0ac0c&scoped=true&"
import script from "./SignInWithGoogle.vue?vue&type=script&lang=js&"
export * from "./SignInWithGoogle.vue?vue&type=script&lang=js&"
import style0 from "./SignInWithGoogle.vue?vue&type=style&index=0&id=71f0ac0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0ac0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cam\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f0ac0c')) {
      api.createRecord('71f0ac0c', component.options)
    } else {
      api.reload('71f0ac0c', component.options)
    }
    module.hot.accept("./SignInWithGoogle.vue?vue&type=template&id=71f0ac0c&scoped=true&", function () {
      api.rerender('71f0ac0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/amplify/SignInWithGoogle.vue"
export default component.exports